<template>
  <div class="login-form">
    <Form ref="AuthenticationForm" :model="authData" :rules="authRules">
      <FormItem prop="Email">
        <i-input type="email" v-model="authData.Email" placeholder="Email" gh>
          <Icon type="ios-person-outline" slot="prepend"></Icon>
        </i-input>
      </FormItem>
      <FormItem prop="Password">
        <i-input
          type="password"
          v-model="authData.Password"
          placeholder="Password"
        >
          <Icon type="ios-lock-outline" slot="prepend"></Icon>
        </i-input>
      </FormItem>
      <FormItem>
        <Button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit()"
          long
        >
          <span v-if="!submitLoading">Signin</span>
          <span v-else>Processing...</span>
        </Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
  import {bus} from "../../main";
  import { login, setSession } from "../../_services/authentication.service";

export default {
  name: "Login",
  data() {
    return {
      authData: {
        Email: "",
        Password: ""
      },
      authRules: {
        Email: [
          {
            required: true,
            message: "Please fill in the user email",
            trigger: "blur"
          }
        ],
        Password: [
          {
            required: true,
            message: "Please fill in the password.",
            trigger: "blur"
          },
          {
            type: "string",
            min: 6,
            message: "The password length cannot be less than 6 bits",
            trigger: "blur"
          }
        ]
      },
      submitLoading: false
    };
  },

  created() {
    // reset login status
    // this.logout();
  },
  methods: {
    handleSubmit() {
      this.$refs.AuthenticationForm.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          login(this.authData)
            .then(res => {
              setSession();
              this.submitLoading = false;
              localStorage.setItem('user_email',this.authData.Email)
              this.$router.push({ name: "administrator" });
            })
            .catch(err => {
              bus.$emit('requestError',err)
              this.submitLoading = false;
              this.$Message.error("Authentication Failed!");
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.login-form {
  width: 300px;
}
</style>
